export const getOsType = () => {
  const agent = navigator.userAgent.toLowerCase();
  const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    return 'win32';
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    return 'win64';
  }
  if (isMac) {
    return 'mac';
  }
};

export const downloadCanvas = (canvasNode) => {
  const a = document.createElement('a');
  const body = document.body;
  a.download = 'image';
  a.href = canvasNode.toDataURL();
  a.style.display = 'none';
  body.appendChild(a);
  a.click();
  body.removeChild(a);
};

export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

try {
  globalThis.STARFLOW.downloadCanvas = downloadCanvas;
} catch {}
